import React, { useEffect } from 'react';
export default function Index() {
  useEffect(() => {
    if (window.location.hostname === 'localhost') {
      return window.location.replace('/en/main-home')
    }
    if (window.location.pathname === '/') {
      window.location.replace('/cn')
    }
  }, [])
  return (
    <div>
    </div>
  )
}
